import { Component } from '@angular/core';

@Component({
  selector: 'app-bulk-asset-landing',
  templateUrl: './bulk-asset-landing.component.html',
  styleUrls: ['./bulk-asset-landing.component.scss']
})
export class BulkAssetLandingComponent {

}
